import {
  FormContext
} from "../__chunks/P3I4MECH.js";
import {
  useButton
} from "../__chunks/O6CV6VRM.js";
import "../__chunks/P4RGQGTG.js";
import {
  useCollectionItem
} from "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import {
  useEvent
} from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/form/form-push.ts
import { useCallback, useContext, useEffect, useState } from "react";
import { invariant } from "@ariakit/core/utils/misc";
function getFirstFieldsByName(items, name) {
  if (!items)
    return [];
  const fields = [];
  for (const item of items) {
    if (item.type !== "field")
      continue;
    if (!item.name.startsWith(name))
      continue;
    const nameWithIndex = item.name.replace(/(\.\d+)\..+$/, "$1");
    const regex = new RegExp(`^${nameWithIndex}`);
    if (!fields.some((i) => regex.test(i.name))) {
      fields.push(item);
    }
  }
  return fields;
}
var useFormPush = createHook(
  (_a) => {
    var _b = _a, {
      store,
      value,
      name: nameProp,
      getItem: getItemProp,
      autoFocusOnClick = true
    } = _b, props = __objRest(_b, [
      "store",
      "value",
      "name",
      "getItem",
      "autoFocusOnClick"
    ]);
    const context = useContext(FormContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormPush must be wrapped in a Form component"
    );
    const name = `${nameProp}`;
    const [shouldFocus, setShouldFocus] = useState(false);
    useEffect(() => {
      var _a2;
      if (!shouldFocus)
        return;
      const items = getFirstFieldsByName(store == null ? void 0 : store.getState().items, name);
      const element = (_a2 = items == null ? void 0 : items[items.length - 1]) == null ? void 0 : _a2.element;
      if (!element)
        return;
      element.focus();
      setShouldFocus(false);
    }, [store, shouldFocus, name]);
    const getItem = useCallback(
      (item) => {
        const nextItem = __spreadProps(__spreadValues({}, item), { type: "button", name });
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [name, getItemProp]
    );
    const onClickProp = props.onClick;
    const onClick = useEvent((event) => {
      onClickProp == null ? void 0 : onClickProp(event);
      if (event.defaultPrevented)
        return;
      store == null ? void 0 : store.pushValue(name, value);
      if (!autoFocusOnClick)
        return;
      setShouldFocus(true);
    });
    props = __spreadProps(__spreadValues({}, props), {
      onClick
    });
    props = useButton(props);
    props = useCollectionItem(__spreadProps(__spreadValues({ store }, props), { getItem }));
    return props;
  }
);
var FormPush = createComponent((props) => {
  const htmlProps = useFormPush(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormPush.displayName = "FormPush";
}
export {
  FormPush,
  useFormPush
};
